// Icon Imports
import TickOutlineCircle from "../assets/icons/tick-circle-outline-icon.svg";
import ErrorOutlineCircle from "../assets/icons/error-circle-outline-icon.svg";

// formate dates
export const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
};

// Number masking state
export const maskOptions = {
  mask: "R num",
  blocks: {
    num: {
      mask: Number,
      scale: 2,
      thousandsSeparator: ",",
      padFractionalZeros: true,
      normalizeZeros: true,
      radix: ".",
    },
  },
};

// Masking Options to only allow numeric values
export const maskNumberOnlyOptions = {
  mask: Number,
  scale: 0,
  thousandsSeparator: "",
  padFractionalZeros: false,
  normalizeZeros: true,
  radix: ".",
  mapToRadix: ["."],
  min: 0,
  max: Infinity,
  signed: false,
};

/**
 * Formats a number as a currency string.
 *
 * @param {number} amount - The number to format as currency.
 * @returns {string} The formatted currency string displayed as R000.00
 */
export const formatAsCurrency = (amount) => {
  const formatted = new Intl.NumberFormat("en-ZA", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  return `R${formatted.replace(/,/g, ".")}`;
};

// mask phone number
export const maskPhoneNumber = (phoneNumber) => {
  // Convert to string
  phoneNumber = String(phoneNumber);

  // Check if the phone number length is valid (e.g., 10 digits)
  if (phoneNumber.length !== 10) {
    return;
  }

  // Mask the middle digits with asterisks
  const maskedNumber = phoneNumber?.slice(0, 3) + "****" + phoneNumber.slice(7);

  return maskedNumber;
};

// Snackbar settings
export const snackSettings = {
  success: {
    colorClass:
      "rounded-lg bg-gradient-to-b from-light-green-gradient-start to-light-green-gradient-end",
    icon: TickOutlineCircle,
  },
  warning: {
    colorClass: "rounded-lg bg-yellow-200",
    icon: ErrorOutlineCircle,
  },
  unauthorized: {
    colorClass: "rounded-lg bg-yellow-200",
    icon: ErrorOutlineCircle,
  },
  notFound: {
    colorClass: "rounded-lg bg-grey-800",
    icon: ErrorOutlineCircle,
  },
  error: {
    colorClass:
      "rounded-lg bg-gradient-to-b from-red-gradient-start to-red-gradient-end",
    icon: ErrorOutlineCircle,
  },
};
